import React from "react";
import { cn } from "@/lib/utils";

export default function StatCard({ label, value, icon: Icon, accent = false, hint, testId }) {
  return (
    <div
      data-testid={testId}
      className={cn(
        "rounded-xl border border-[#E5E7EB] bg-[#FFFFFF] p-5 transition-colors hover:border-[#94A3B8]",
        accent && "border-[#E63946]/40 bg-gradient-to-br from-[#FEF2F2] to-white"
      )}
    >
      <div className="flex items-center justify-between">
        <div className="text-[11px] uppercase tracking-[0.18em] text-[#64748B] font-bold">{label}</div>
        {Icon && <Icon size={16} className={accent ? "text-[#E63946]" : "text-[#475569]"} />}
      </div>
      <div className="mt-3 text-3xl font-medium text-slate-900" style={{ fontFamily: "'Outfit', sans-serif" }}>{value}</div>
      {hint && <div className="mt-1 text-xs text-[#475569]">{hint}</div>}
    </div>
  );
}
